import {Detail, FlexRow, Pill} from '@forecast-it/design-system';
import React from 'react';

export interface RoutingDisclosureProps {
	agentName: string;
	reason?: string;
}

export const RoutingDisclosure = (props: RoutingDisclosureProps): JSX.Element => (
	<FlexRow>
		<Pill data-cy="nova-agent-chip">{props.agentName}</Pill>
		{props.reason && (
			<Detail data-cy="nova-routing-reason" color="medium">
				{props.reason}
			</Detail>
		)}
	</FlexRow>
);
